import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import {
  CorrespondenceCompanyDto,
  CorrespondenceDepartmentFunctionDto,
} from '@cradua/data';

@Component({
  selector: 'mrsoftapps-function-view',
  templateUrl: './function-view.component.html',
  styleUrls: ['./function-view.component.css'],
})
export class FunctionViewComponent implements OnInit {
  @Input() companies: CorrespondenceCompanyDto[];
  @Input() functions: CorrespondenceDepartmentFunctionDto[];
  functionForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<
    CorrespondenceDepartmentFunctionDto
  >();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedFunction: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredFunction: Array<CorrespondenceDepartmentFunctionDto> = [];
  status: boolean;
  selectedFunctionId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.functionForm = this.fb.group({ Functions: this.fb.array([]) });
  }

  // method to display countries
  setFunction() {
    const control = this.functionForm.controls.Functions as FormArray;
    this.filteredFunction.forEach((e) => {
      control.push(
        this.fb.group({
          CorrespondenceDepartmentFunctionName:
            e.CorrespondenceDepartmentFunctionName,
          CompanyId: e.CompanyId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.functionForm.controls.Functions as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectFunction(event: string) {
    this.filteredFunction = this.functions.filter((s) => s.CompanyId === event);
    this.selectedFunctionId = event;
    const control = this.functionForm.controls.Functions as FormArray;

    if (this.filteredFunction.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setFunction();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addFunction() {
    const control = this.functionForm.controls.Functions as FormArray;
    control.insert(
      0,
      this.fb.group({
        CorrespondenceDepartmentFunctionName: ['', Validators.required],
        CompanyId: this.selectedFunctionId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteFunction(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.functionForm.controls.Functions as FormArray;
        control.removeAt(index);

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'function';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('function');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
